import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
//import { Link } from "react-router-dom";
import Layout from "../../components/common/Layout";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import Alerts from "../layout/Alerts";
import AlertContext from "../../context/alert/alertContext";
import checkTime from "../../components/constants/CheckTime"

const User = props => {
    const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 15)[0];
    const alertContext = useContext(AlertContext);
    const { setAlert } = alertContext;
    const userId =
        JSON.parse(localStorage.getItem("user")) === null
        ? null
        : JSON.parse(localStorage.getItem("user"))[0].Id;
    const usersColumns = [
        {
            cell: row => (
              <div>
                <button
                    hidden={!pagePermission.IsUpdate}
                  className="btn btn-sm btn-primary ml-2"
                  type="button"
                  onClick={() => {
                    setShowEditModal({ show: "Edit", pop: true, Id: row.Id })
                  }}
                >
                  <i className="fa fa-pencil"></i> Edit
                </button>
                <button
                    hidden={!pagePermission.IsDelete}
                  className="btn btn-sm btn-danger ml-2"
                  type="button"
                  onClick={() => {
                    setShowDeleteModel({ Id: row.Id, pop: true })
                  }}
                >
                  <i className="fa fa-remove"></i> Delete
                </button>
              </div>
            ),
            ignoreRowClick: false,
            allowOverflow: true,
            width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "180px" : "0px",
            button: true,
        },
        {
            name: "UserName",
            selector: "UserName",
            sortable: true,
            wrap: true
        },
        {
            name: "Role",
            selector: "RoleName",
            sortable: true,
            wrap: true
        },
        {
            name: "Title",
            selector: "Title",
            sortable: true,
            wrap: true
        },
        {
            name: "Name",
            selector: "Name",
            sortable: true,
            wrap: true
        },
        {
            name: "MiddleName",
            selector: "MiddleName",
            sortable: true,
            wrap: true
        },
        {
            name: "Surname",
            selector: "Surname",
            sortable: true,
            wrap: true
        },
        {
            name: "EmailAddress",
            selector: "EmailAddress",
            sortable: true,
            wrap: true
        },
        {
            name: "Status",
            selector: "StatusActive",
            sortable: true,
            center: true,
            cell: row => (
              <div>
                { !row.StatusActive && (
                  <h6>
                    <span className="badge badge-danger text-left">InActive</span>
                  </h6>
                )}
                { row.StatusActive && (
                  <h6>
                    <span className="badge badge-success text-left">Active</span>
                  </h6>
                )}
              </div>
            )
        },
        {
            name: "CreationTime",
            selector: "CreationTime",
            sortable: true,
            wrap: true
        },
        {
            name: "Creator",
            selector: "Creator",
            sortable: true,
            wrap: true
        },
        {
            name: "LastUpdateBy",
            selector: "LastUpdateBy",
            sortable: true,
            wrap: true
        },
        {
            name: "LastUpdateDateTime",
            selector: "LastUpdateDateTime",
            sortable: true,
            wrap: true
        },
    ];
    const [ usersData, setUsersData] = useState([]);
    const reloadUsers = () => {
        axios
        .get(process.env.REACT_APP_API_URL + "/api/user", {
            params: userFromSearch
        })
        .then(res => {
            setUsersData(res.data);
        });
    }
    const [ userFromSearch, setUserFromSearch ] = useState({
        user : '',
        email: '',
        name: '',
        surname: '',
        roleId: 0
    })
    const defaultModal = { show: "", pop: false, Id: ""  };
    const [showEditModal, setShowEditModal] = useState(defaultModal);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showDeleteModal, setShowDeleteModel] = useState({ Id: "", pop: false });
    const [ roleDdl, setRoleDdl] = useState([{ value: 0, label: "Select" }])
    const [ userEdit, setUserEdit] = useState({
        user: '',
        role: 0,
        title: 'Mr.',
        name: '',
        middle: '',
        surname: '',
        email: '',
        pass: '',
        pass2: '',
        createBy: userId
    })
    const [ showEditPass, setShowEditPass] = useState(false);
    const hasNumber = (str) => {
        let check = false;
        for (let i = 0; i < str.length; i++) {
            if('1234567890'.includes(str[i])){
                check = true;
                return check;
            }
        }
        return check;
    }
    useEffect(() => {
        checkTime();
        document.addEventListener("mousedown",  (e) => { checkTime(); });
        reloadUsers();
        axios
        .get(process.env.REACT_APP_API_URL + "/api/role/ddl")
        .then(res => {
            setRoleDdl(res.data);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    useEffect(() => {
        if(showEditModal.pop && showEditModal.show === 'Edit'){
            axios
            .get(process.env.REACT_APP_API_URL + "/api/user/" + showEditModal.Id)
            .then(res => {
                setUserEdit({
                    user: res.data[0].UserName,
                    role: res.data[0].RoleId,
                    title: res.data[0].Title,
                    name: res.data[0].Name,
                    middle: res.data[0].MiddleName,
                    surname: res.data[0].Surname,
                    email: res.data[0].EmailAddress,
                    pass: '',
                    pass2: '',
                    createBy: userId
                });
            });
        }else{
            setShowEditPass(false);
            setUserEdit({
                user: '',
                role: 0,
                title: 'Mr.',
                name: '',
                middle: '',
                surname: '',
                email: '',
                pass: '',
                pass2: '',
                createBy: userId
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[showEditModal.pop])
    useEffect(() => {
        if(!showEditPass){ setUserEdit({ ...userEdit, pass : '', pass2: '' }) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[showEditPass])
    

    const saveUser = () => {
        if (showEditModal.show === "Add") {
            axios
            .post(
                process.env.REACT_APP_API_URL +
                "/api/user/" , userEdit
            )
            .then(res => {submitSave(res); }
            );
        } else if (showEditModal.show === "Edit") {
            axios
            .put(
                process.env.REACT_APP_API_URL +
                "/api/user/" + showEditModal.Id , userEdit
            )
            .then(res => {submitSave(res); }
            );
        }
        const submitSave = res => {
            setShowConfirm(false);
            if (res.data.status === "0") {
                setAlert(res.data.msg, "success");
                reloadUsers();
                setShowEditModal(defaultModal);
            } else {
                setAlert(res.data.msg, "danger");
                //setShowEditModal(defaultModal);
            }
        }
    }
    
    return (
        <Layout activeLinkTo="/users" menuId="15">
            <div className="container-fluid" style={{ minHeight: 500 }}>
                <Alerts />
                <div className="card border-secondary">
                    <h5 className="card-header text-white bg-primary">Users</h5>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="title control-label">User</label>
                                <input
                                    type="search"
                                    className="form-control"
                                    value={userFromSearch.user}
                                    onKeyUp={ e => e.keyCode === 13 ? reloadUsers(): null }
                                    onChange={e => setUserFromSearch({ ...userFromSearch, user: e.target.value }) }
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="title control-label">Email</label>
                                <input
                                    type="search"
                                    className="form-control"
                                    value={userFromSearch.email}
                                    onKeyUp={ e => e.keyCode === 13 ? reloadUsers(): null }
                                    onChange={e => setUserFromSearch({ ...userFromSearch, email: e.target.value }) }
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="title control-label">Name</label>
                                <input
                                    type="search"
                                    className="form-control"
                                    value={userFromSearch.name}
                                    onKeyUp={ e => e.keyCode === 13 ? reloadUsers(): null }
                                    onChange={e => setUserFromSearch({ ...userFromSearch, name: e.target.value }) }
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="title control-label">Surname</label>
                                <input
                                    type="search"
                                    className="form-control"
                                    value={userFromSearch.surname}
                                    onKeyUp={ e => e.keyCode === 13 ? reloadUsers(): null }
                                    onChange={e => setUserFromSearch({ ...userFromSearch, surname: e.target.value }) }
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="title control-label">Role </label>
                                <Select 
                                    onChange={ e => setUserFromSearch( { ...userFromSearch, roleId: e.value } ) }
                                    value={ [ { value: 0, label: "Select All" }, ...roleDdl].filter(x => x.value === userFromSearch.roleId) }
                                    options={[ { value: 0, label: "Select All" }, ...roleDdl]}
                                />
                            </div>
                        </div>
                        <div className="row mt-2 float-right">
                            <div className="col">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => reloadUsers()}
                                >
                                    <i className="fa fa-search"></i> Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
                <div className="card border-secondary">
                    <h5 className="card-header text-white bg-primary">Data</h5>
                    <div className="card-body">
                        <div className="table-responsive" style={{padding:"10px 0"}}>
                            <button
                                hidden={!pagePermission.IsCreate}
                                type="button"
                                className="btn btn-success"
                                onClick={() => setShowEditModal({ show: "Add", pop: true, Id: "" }) }
                            >
                                <i className="fa fa-plus"></i> Add
                            </button>
                            <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                                <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                            </a>
                            <DataTable
                                noHeader={true}
                                pagination={true}
                                paginationPerPage={50}
                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                columns={usersColumns}
                                data={usersData}
                            />
                            <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                                <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Madal confirm add/edit */}
            <Modal
            show={showConfirm}
            onHide={() => {
                setShowConfirm(false);
            }}
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            {/*<Modal.Body><Alerts /></Modal.Body>*/}
            <Modal.Footer>
                <button
                    className="btn btn-danger ml-2"
                    onClick={() => {
                        setShowConfirm(false);
                    }}
                >
                <i className="fa fa-reply"></i> Cancel
                </button>
                <button
                    className="btn btn-success ml-2"
                    type="button"
                    onClick={() => {
                        saveUser();
                    }}
                >
                <i className="fa fa-floppy-o"></i> Save
                </button>
            </Modal.Footer>
            </Modal>
            {/* Madal confirm add/edit */}

            {/* Modal Delete address */}
            <Modal
                show={showDeleteModal.pop}
                onHide={() => {
                    setShowDeleteModel({ Id: "", pop: false });
                }}
                centered
                >
                <Modal.Header closeButton>
                    <div
                    style={{
                        width: 39,
                        height: 39,
                        borderWidth: 4,
                        borderStyle: "solid",
                        borderColor: "red",
                        borderRadius: "50%",
                        position: "relative"
                    }}
                    >
                    <span
                        style={{
                        width: 24,
                        height: 5,
                        position: "absolute",
                        backgroundColor: "red",
                        top: 13,
                        left: 3,
                        transform: "rotate(45deg)"
                        }}
                    ></span>
                    <span
                        style={{
                        width: 24,
                        height: 5,
                        position: "absolute",
                        backgroundColor: "red",
                        top: 13,
                        left: 3,
                        transform: "rotate(-45deg)"
                        }}
                    ></span>
                    </div>
                    <Modal.Title style={{ paddingLeft: 13 }}>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please make sure Once deleted, items cannot be returned.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                            setShowDeleteModel({ Id: "", pop: false });
                        }}
                        >
                        <i className="fa fa-reply"></i> Cancel
                    </button>
                    <button
                    className="btn btn-danger ml-2"
                    type="button"
                    onClick={async () => {
                        await axios
                        .put(
                            process.env.REACT_APP_API_URL +
                            "/api/user/delete/" +
                            showDeleteModal.Id,
                            {
                            createBy: userId
                            }
                        )
                        .then(res => {
                            setShowDeleteModel({ Id: "", pop: false });
                            setAlert(res.data.msg, "danger");
                            reloadUsers();
                        });
                    }}
                    >
                    <i className="fa fa-trash-o"></i> Continue
                    </button>
                </Modal.Footer>
            </Modal>
            {/* Modal Delete address*/}

            {/* Modal Add/Edit User*/}
            <Modal
                show={showEditModal.pop}
                onHide={() => setShowEditModal(defaultModal) }
                centered
                dialogClassName="modal-w"
                //size="lg"
            >
            <Modal.Header closeButton>
                {showEditModal.show === "Add" && <Modal.Title>Add User</Modal.Title>}
                {showEditModal.show === "Edit" && <Modal.Title>Edit User</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
                <div className="form-group col labelPadRight">
                    <Alerts />
                    <div className="table">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="title control-label">User <span style={{ color: "red" }}> * </span></label>
                                <input
                                    className="form-control"
                                    value={userEdit.user}
                                    onChange={e => setUserEdit({ ...userEdit, user: e.target.value }) }
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="title control-label">Role <span style={{ color: "red" }}> * </span></label>
                                <Select 
                                    onChange={ e => setUserEdit( { ...userEdit, role: e.value } ) }
                                    value={ roleDdl.filter(x => x.value === userEdit.role) }
                                    options={roleDdl}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="title control-label">Name <span style={{ color: "red" }}> * </span></label>
                                <div className="input-group">
                                    <div className="input-group-prepend" style={{ cursor: "pointer"}}>
                                        <span className="input-group-text"
                                            onClick={() => 
                                                setUserEdit({ ...userEdit, title: (userEdit.title === 'Mr.'? 'Ms.': 'Mr.') })
                                            }
                                        >{userEdit.title}</span>
                                    </div>
                                    <input
                                        className="form-control  col-lg-4"
                                        placeholder="name"
                                        value={userEdit.name}
                                        onChange={e => setUserEdit({ ...userEdit, name: e.target.value }) }
                                    />
                                    <input
                                        className="form-control  col-lg-4"
                                        placeholder="middleName"
                                        value={userEdit.middle}
                                        onChange={e => setUserEdit({ ...userEdit, middle: e.target.value }) }
                                    />
                                    <input
                                        //type="search"
                                        className="form-control  col-lg-4"
                                        placeholder="surname"
                                        value={userEdit.surname}
                                        onChange={e => setUserEdit({ ...userEdit, surname: e.target.value }) }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12">
                            <label className="title control-label">Email <span style={{ color: "red" }}> * </span></label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={userEdit.email}
                                    onChange={e => setUserEdit({ ...userEdit, email: e.target.value }) }
                                />
                            </div>
                        </div>
                        <div className="row" 
                            hidden = {showEditModal.show ==='Edit' ? false : true} 
                            onClick = {(e) => setShowEditPass(!showEditPass)}>
                            <label style = {{color: "cornflowerblue"}}> 
                                <i className={"fa fa-chevron-" + (showEditPass ? 'down' : 'right')} /> edit password 
                            </label>
                        </div>
                        <div className="row" hidden = {showEditModal.show ==='Add' || showEditPass ? false : true}>
                            <div className="col-md-12">
                                <label className="title control-label">Password 
                                    <span style={{ color: "red" }}> * </span>
                                    <span style={{ color: "gray"}}>(combination of 8 letters and numbers)</span>
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={userEdit.pass}
                                    onChange={e => setUserEdit({ ...userEdit, pass: e.target.value }) }
                                />
                            </div>
                        </div>
                        <div className="row" hidden = {showEditModal.show ==='Add' || showEditPass ? false : true}>
                            <div className="col-md-12">
                                <label className="title control-label">Confirm Password <span style={{ color: "red" }}> * </span></label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={userEdit.pass2}
                                    onChange={e => setUserEdit({ ...userEdit, pass2: e.target.value }) }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="text-right">
                    <button
                        className="btn btn-danger ml-2"
                        onClick={() => setShowEditModal(defaultModal) }
                    >
                        <i className="fa fa-reply"></i> Cancel
                    </button>
                    <button
                        className="btn btn-success ml-2"
                        type="button"
                        onClick={() => {
                            if ( userEdit.user === "" || userEdit.role === 0 || userEdit.name === '') {
                                setAlert("form is null! Plese fill form", "warning");
                            } else if ( userEdit.email === '' || userEdit.email.indexOf("@") <= 0) {
                                setAlert("please fill email", "warning");
                            } else if ( userEdit.pass === "" && showEditModal.show === 'Add' ){
                                setAlert("password is null! Plese fill form", "warning");
                            } else if ( userEdit.pass !== '' && (userEdit.pass.length < 8 || !isNaN(userEdit.pass) || !hasNumber(userEdit.pass) ) ){
                                setAlert("please enter a password with a combination of 8 letters and numbers", "warning");
                            } else if ( userEdit.pass !== userEdit.pass2){
                                setAlert("Password Mismatch", "warning");
                            } else {
                                setShowConfirm(true);
                            }
                        }}              
                    >
                        {showEditModal.show === "Add" && <i className="fa fa-plus"> Add </i> }
                        {showEditModal.show === "Edit" && <i className="fa fa-floppy-o"> Save</i> }
                    </button>
                </div>
            </Modal.Footer>
            </Modal>
            {/* Modal Add/Edit User */}


        </Layout>
    );
};

export default User;